// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2amKn","box":"WorkspacesBox_box__189-i","node":"WorkspacesBox_node__cn13L"};